import { useEffect } from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import { useLanguage } from '../contexts/LanguageContext';
import i18n from '../i18n';

const LanguageRedirect = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const { changeLanguage } = useLanguage();

  useEffect(() => {
    // Extract language from pathname (/cz or /en)
    const pathLang = location.pathname.slice(1).toLowerCase();
    
    // Map route language codes to i18n language codes
    const languageMap = {
      'cz': 'cs',
      'en': 'en'
    };

    if (languageMap[pathLang]) {
      // Set the language
      const language = languageMap[pathLang];
      changeLanguage(language);
      i18n.changeLanguage(language);
      // Save to localStorage
      localStorage.setItem('eevn-language', language);
    }

    // Redirect to home page
    navigate('/', { replace: true });
  }, [location.pathname, navigate, changeLanguage]);

  return null;
};

export default LanguageRedirect;

